import React, { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { CROSS_REGION_PROFILE_SEARCH } from "api/graphql/queries";
import { getRegionList, getShortName, getBlockImg } from "lib/region_helper";
import { getRiotAssetsContext, getS13RankUrl } from "@outplayed/riot-assets";
import { capitalizeFirstLetter } from "lib/general-helper";
import { Link } from "react-router-dom";

const ErrorSummonerNotFound = (props) => {
  const { getProfileIconImg } = getRiotAssetsContext();
  const { summonerName } = props;
  const { data, loading } = useQuery(CROSS_REGION_PROFILE_SEARCH, {
    ssr: false,
    variables: {
      summonerName: summonerName,
    },
  });

  if (loading) {
    return (
      <div style={{ position: "absolute", top: "50%", left: "50%" }}>
        <div className="spinthatshit-loader">
          <div className="spinner" />
        </div>
      </div>
    );
  }

  let regionBlockImgs = getRegionList().map((region) => {
    return getBlockImg(region, true);
  });

  let regionList = getRegionList().map((region) => {
    return getShortName(region);
  });

  let regionToUserMap = {};

  if (data && data.crossRegionProfileSearch) {
    data.crossRegionProfileSearch.forEach((user) => {
      const { playerInfo } = user;

      const region = getShortName(playerInfo.regionId);
      regionToUserMap[region] = user;
    });
  }

  return (
    <div className="summoner-not-found-error">
      <div className="text-header">
        <div className="white-bold">Oh no! We couldn't find summoner "{summonerName}"</div>
        <div className="white-normal">
          Double check your spelling or check out these summoners with this name in other regions.
        </div>
      </div>
      <div>
        {regionList.map((region, index) => {
          const user = regionToUserMap[region];
          let iconId, summonerName, tier, rank;
          let summonerNameClass = "";

          if (user && user.playerInfo) {
            iconId = user.playerInfo.iconId;
            summonerName = user.playerInfo.summonerName;
            summonerNameClass = "valid-profile";
          }

          tier = "unranked";
          rank = "";
          if (user && user.soloQueueRank) {
            tier = user.soloQueueRank.tier;
            rank = user.soloQueueRank.rank;
          }

          return (
            <div key={index} className="region-row">
              <div className="main-content">
                <div className="left-section">
                  <img className="region-img" src={regionBlockImgs[index]} />
                  {iconId ? <img className="profile-icon" src={getProfileIconImg(iconId)} /> : null}
                  {summonerName ? (
                    <Link to={`/lol/profile/${getRegionList()[index]}/${summonerName}/overview`}>
                      <div className={`summoner-name ${summonerNameClass}`}>{summonerName}</div>
                    </Link>
                  ) : (
                    <div className="summoner-name">-</div>
                  )}
                </div>
                {user && tier && (
                  <div className="rank-section">
                    <img className="rank-icon" src={getS13RankUrl(tier, true)} />
                    <div className="rank-text">{capitalizeFirstLetter(tier)}</div>
                    <div className="rank-div">{rank.toUpperCase()}</div>
                  </div>
                )}
              </div>
              <div className="divider" />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ErrorSummonerNotFound;
